import { ApiConnector, GET } from './request.service';

export default (() => {
  const API = ApiConnector('/groups');
  return {
    GetCityGroups: async (cityId) =>
      await API(GET, `/${cityId}`, false, {
        token: '!Aa12345',
        purpose: 'schedule',
        t: Number(new Date().getTime()),
      }).call(),
    GetOnlineGroups: async (cityId) =>
      await API(GET, `/online/${cityId}`, false, {
        token: '!Aa12345',
        purpose: 'schedule',
        t: Number(new Date().getTime()),
      }).call(),
  };
})();
